// CONSTANTS are all caps.
const NS = 'SocialBar';
const CLS = 'socialBar';
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/socialBar.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class SocialBar {

	constructor($el) {
		// $el is the widget node return by the loadSocialBar function
		this.$el = $el;
	}

	init() {
		this.initSocialBar();

		// let hasAffix = !this.$el.classList.contains('modalChild') && !this.$el.classList.contains('newsTemplate-socialBar');
		// if (hasAffix) {
		// 	setTimeout(() => {
		// 		this.affixSocialBar();
		// 	}, 500);
		// }

		this.onModalShow();
	}

	initSocialBar() {
		const socialButtons = this.$el.querySelectorAll('.socialBar-button');

		Array.from(socialButtons).forEach( (item) => {
			const social = item.getAttribute('data-social');
			const currentPage = window.location.href;

			switch (social) {
				case 'facebook':
					item.setAttribute('href', `http://www.facebook.com/sharer.php?u=${currentPage}`);
					break;
				case 'twitter':
					item.setAttribute('href', `https://twitter.com/share?url=${currentPage}&amp;text=`);
					break;
				case 'linkedin':
					item.setAttribute('href', `http://www.linkedin.com/shareArticle?mini=true&amp;url=${currentPage}`);
					break;
				case 'pinterest':
					item.setAttribute('href', `https://pinterest.com/pin/create/button/?url=${currentPage}&media=&description=`);
					break;
				case 'instagram':
					item.setAttribute('href', `https://www.instagram.com/thewoolmarkcompany/?hl=en`);
					break;
			}
		});
	}

	affixSocialBar() {
		const wgTopOffset = $(this.$el).offset().top - 70;
		const wg = $(this.$el);

		$(window).scroll(function() {
			// console.log(`window: ${$(window).scrollTop()}; wg: ${wgTopOffset}`);
			if (document.documentElement.clientWidth >= 1200) {
				if ($(window).scrollTop() > wgTopOffset) {
					wg.attr('style', `position: fixed !important; top: 40px; z-index: 1001;`); // 99999
				} else {
					wg.removeAttr('style');
				}
			}
		});
	}

	onModalShow() {
		$(WG + 'modal').on('shown.bs.modal', () => {
			$('.modal-backdrop.fade.show').css('opacity', '.5');
		});
	}
}
